/**
 * © 2022 Patrick Lammers & Dirk Lammers
 */

export enum OAuthGrantTypes {
  PASSWORD = "password",
  CLIENT_CREDENTIALS = "client_credentials",
  REFRESH_TOKEN = "refresh_token"
}